module.exports = __webpack_public_path__ + "fonts/Roboto-Thin.06ca73d.woff2";